import { _Field } from "../fields/types.js";
import { getValueForUICultureBinder } from "./funcs.js";
_Field.prototype.titleResource = getValueForUICultureBinder("titleResource");
_Field.prototype.descriptionResource = getValueForUICultureBinder("descriptionResource");
//# sourceMappingURL=field.js.map